var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"card",attrs:{"role":"main"}},[_c('h1',[_vm._v("Zawartość")]),_c('div',{staticClass:"meta"},[_vm._v("Pobieranie /api automatyczne po załadowaniu strony")]),_c('pre',{class:{ error: _vm.isError }},[_vm._v(_vm._s(_vm.output))]),_c('router-link',{attrs:{"to":{ name: 'example' }}},[_vm._v("Example")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }